var App = App || {};

App.Accordions = (function ($) {
    'use strict';

    function init() {

        if ($(".section.section-accordion").length) {
            $(".section.section-accordion").each(function () {

                const accordions = $(this).find(".accordion");

                accordions.each(function () {

                    const component = $(this).parents(".section-accordion");
                    const accordion = $(this);
                    const viewMore = component.find(`button[aria-controls=\"${accordion.attr("id")}\"]`);

                    viewMore.on("click", function () {
                        if ($(this).attr("aria-expanded") == "false") {
                            $(this).attr("aria-expanded", "true").text("View Less");
                            accordion.find(".accordion-item.zag-d-none").addClass("accordion-item-conditional").removeClass("zag-d-none");
                        }
                        else if ($(this).attr("aria-expanded") == "true") {
                            $(this).attr("aria-expanded", "false").text("View More");
                            accordion.find(".accordion-item.accordion-item-conditional").removeClass("accordion-item-conditional").addClass("zag-d-none");
                        }
                    });
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Accordions.init();
});